import PurchaseLinkButtons from './PurchaseLinkButtons'
import { PurchaseChannelConfig } from '../types'

interface PurchaseButtonsProps {
  purchaseChannels: PurchaseChannelConfig[]
  onAmazonClick: () => void
  onRakutenClick: () => void
}

export default function PurchaseButtons({
  purchaseChannels,
  onAmazonClick,
  onRakutenClick,
}: PurchaseButtonsProps) {
  return (
    <section className='relative sticky bottom-0 w-full'>
      <div className='shadow-line' />
      <div className='p-2 text-center bg-white'>
        <PurchaseLinkButtons
          purchaseChannels={purchaseChannels}
          onAmazonClick={onAmazonClick}
          onRakutenClick={onRakutenClick}
        />
      </div>
    </section>
  )
}
